
import { name } from '../../package.json'

export default {
  'fr-FR': {
    title: {
      initialisation: 'Initialisation ' + name,
      index_pdv: 'Choix du point de vente',
      info_badge: 'Infos badge',
      info_commande: 'Infos commande',
      scan_voucher: 'Vouchers',
      settings: 'Paramètres',
      ticket: 'Ticket',
      gift_scan: 'Scan de titres cadeaux',
      solde_transfer: 'Transfert de solde',
      client_cards: 'Supports client',
      client_add_card: 'Ajout d\'un support client',
      client_edit: 'Fiche client',
      client_search: 'Recherche client',
      parameters_lot_credit: 'Chargement de titres cadeaux',
      gift_credit: 'Activation carte cadeau',
      gift_debit: 'Débit carte cadeau',
      loyalty_jackpot: 'Cagnotte fidélité',
      loyalty_offers: 'Offres fidélité',
      loyalty_questions: 'Questions fidélité',
      vouchers: 'Utilisation de vouchers',
      mobil_scan: 'Scan de carte Mobil',
      mobil_products: 'Sélection produits',
      mobil_payment: 'Paiement Mobil',
      cashless_reload: 'Rechargement Cashless',
      cashless_reload_cb: 'Rechargement CB',
      cashless_cancel: 'Annulation {type}',
      scan_choice: 'Choix du scan',
      amount_capture: 'Saisie du montant',
      amount_purchase: 'Montant de l\'achat',
      amount_tips: 'Montant du pourboire',
      amount_transfer: 'Montant à transférer',
      validity_date: 'Date de fin de validité',
      validity_date_selection: 'Sélectionnez une date de fin de validité',
      birth_date: 'Date de naissance',
      birth_date_selection: 'Sélectionnez une date de naissance',
      offline_trx_nb: '{nb} transactions offline stockées',
      ticket_manage: 'Gestion des tickets bancaires',
      connection: 'Connexion',
      requests: 'Requêtes',
      reports: 'Rapports',
      article_details: 'Détail articles',
      article_price: 'Prix de l\'article',
      customer_loyalty_cards: 'Cartes de fidélité',
      settings_actions: 'Actions rapides',
      settings_printer: 'Imprimante',
      settings_no_printer: 'Aucune imprimante bluetooth trouvée',
      settings_select_printer: 'Sélectionnez une imprimante',
      settings_scan_choice: 'Choix du scan',
      settings_scan_choice_desc: 'En fonction des caractéristiques de votre appareil, vous pouvez activer ou désactiver des méthodes de scan, ainsi que d\'en définir une favorite',
      settings_lang: 'Langues',
      settings_lock: 'Verrouillage',
      settings_lock_desc: 'Vous pouvez définir un mot de passe pour limiter l\'accès à certaines fonctionnalités du menu principal, comme les paramètres ou la déconnexion',
      settings_others: 'Autres paramètres',
      give_tips: 'Souhaitez-vous donner un pourboire ?',
      give_tips_amount: 'Quel montant souhaitez-vous donner ?',
      give_donation: 'Souhaitez-vous faire un don de ',
      donations: 'Dons',
      tips: 'Pourboires',
      cashlessRefill: 'Rechargement cashless en ligne'
    },
    enums: {
      type_scan: {
        nfc: 'Sans contact',
        qr: 'QR Code',
        swipe: 'Piste',
        manual: 'Saisie manuelle',
        qr_usb: 'QR Code USB'
      },
      orientation: {
        portrait: 'Portrait',
        landscape: 'Paysage',
        invert_portrait: 'Portrait inversé',
        invert_landscape: 'Paysage inversé'
      },
      env: {
        choice: 'Choix de l\'environnement',
        settings: 'Accéder aux paramètres',
        bdd: 'Exporter la bdd',
        pax_bdd: 'Exporter la bdd PAX',
        prod: 'Production',
        int: 'Intégration',
        dev: 'Développement'
      }
    },
    words: {
      payment: 'Paiement',
      valid: 'Valider',
      disable: 'Désactiver',
      disabled: 'Désactivation',
      deactivationRange: 'Plage de désactivation',
      reactivation: 'Réactivation',
      cancel: 'Annuler',
      cancelled: 'annulé',
      refused: 'refusé',
      ripped_card: 'Carte arrachée',
      trx: {
        refused: 'Transaction refusée',
        cancelled: 'Transaction annulée',
        error: 'Transaction en erreur'
      },
      left_to_pay: 'Reste à payer',
      solde: 'Solde',
      amount: 'Montant',
      beneficiary: 'Bénéficiaire',
      gateway: 'Passerelle',
      instance: 'Instance'
    },
    tickets: {
      old_solde: 'ANCIEN SOLDE',
      activation_fees: 'FRAIS ACTIVATION',
      new_solde: 'NOUV. SOLDE',
      follow_us: 'Suivez votre compte cashless en vous inscrivant sur',
      add_code: 'Ajoutez votre badge avec le code',
      thx: 'MERCI A BIENTOT',
      reload: 'RECHARGEMENT',
      payment: 'PAIEMENT',
      cancel_reload: 'ANNULATION RECHARGEMENT',
      cancel_payment: 'ANNULATION PAIEMENT',
      offline_site: 'Suivez votre compte cashless en vous inscrivant sur',
      offline_code: 'Ajoutez votre badge avec le code'
    },
    field: {
      index: {
        user: 'Email',
        password: 'Mot de passe',
        pdv: 'Point de vente',
        licence: 'Licence',
        rank: 'Rang',
        version: 'Version de'
      },
      pax: {
        web_service_url: 'Nepting web service URL',
        merchant_code: 'ID commerçant Nepting',
        server: 'Serveur de production',
        pos_number: 'Numéro de terminal'
      },
      settings: {
        print_merchant_ticket: 'Impression du ticket commerçant',
        print_client_ticket: 'Impression du ticket client',
        manage_tickets: 'Gestion des tickets bancaire par myTerminal',
        do_remote_settings: 'Effectuer un téléparamétrage',
        update_catalog: 'Actualiser le catalogue',
        update_app: 'Mettre à jour myTerminal',
        language: 'Langage',
        orientation: 'Orientation de l\'écran',
        passwd: 'Mot de passe',
        scan_tech: 'Technologie de scan par défaut',
        contactless: 'Sans contact',
        qr_code: 'QrCode',
        man_scan: 'Saisie manuelle',
        swipe: 'Lecture piste',
        vibration: 'Vibration touches',
        startWithAndroid: 'Démarrer avec Android',
        lock_standby: 'Blocage mise en veille',
        darkening: 'Assombrissement',
        darkening_delay: 'Délai d\'assombrissement',
        remote_auto: 'Téléparamétrage auto',
        printer_connected: 'Connectée:',
        printer_forgot: 'Oublier<br>l\'imprimante',
        printer_test: 'Test<br>d\'impression',
        printer_connect_new: 'Connecter une<br>imprimante bluetooth',
        seuil_min: 'Seuil min',
        any_minimal_threshold: 'Aucun seuil minimal'
      },
      scan: {
        pin_code_capture: 'Saisie du code {type}',
        pin_code: 'Code {type}',
        thx_presenting: 'Merci de présenter',
        thx_again: 'de nouveau',
        ur_badge: 'votre badge pour informations',
        ur_support: 'votre support',
        ur_payment: 'votre moyen de règlement',
        ur_cashier_card: 'votre carte caissier',
        recharge: 'Rechargement de',
        dispo: 'disponible',
        cancel_recharge: 'Annuler le rechargement',
        support_number: 'Numéro de support',
        transaction_number: 'Numéro de transaction',
        group_op: 'Opération par lot',
        program_selection: 'Selection du programme',
        program_bail: 'Caution',
        program_date_start: 'Date début',
        program_hour_start: 'Heure début',
        program_date_end: 'Date fin',
        program_hour_end: 'Heure fin',
        reload_code: 'Code de rechargement',
        ticket_number: 'Numéro de billet',
        reload: 'Recharger',
        reload_online: 'Recharger en ligne',
        prepayment: 'Prépaiement en ligne requis',
        no_trx_card: 'Aucune transaction présente sur cette carte',
        cancel_op: 'Annuler cette opération',
        debit: 'Débit',
        credit: 'Crédit',
        credit_online: 'Crédit en ligne',
        cancel_credit: 'Annulation crédit',
        cancel_debit: 'Annulation débit',
        activation_fee: 'Frais d\'activation'
      },
      customer: {
        name: 'Nom',
        firstname: 'Prénom',
        mail: 'Email',
        country_code: 'Code pays',
        country: 'Choisir un pays',
        phone: 'Téléphone',
        phone_number: 'Numéro de téléphone',
        example: 'Exemple :',
        address_search: 'Recherche d\'adresse',
        address_capture: 'Saisir une adresse',
        address: 'Adresse',
        address_comp: 'Complément d\'adresse',
        cp: 'Code Postal',
        city: 'Ville',
        status_registered: 'Inscrit',
        status_to_complet: 'À Renseigner',
        status_disabled: 'Désactivé',
        purchase: 'Enregistrer un achat',
        infos: 'Informations',
        supports: 'Supports',
        mail_name_phone: 'Recherchez un nom, mail, téléphone',
        filter: 'Filtrer les résultats',
        new_customer: 'Nouveau contact',
        create_new_customer: 'Créer un nouveau contact',
        birthDay: 'Date de naissance'
      },
      mobil: {
        no_product: 'Aucun produit disponible',
        quantity: 'Quantité',
        total: 'Montant total',
        add: 'Ajouter',
        edit: 'Modifier',
        total_and: 'Un montant total ET une quantité sont obligatoires',
        total_or: 'Un montant total OU une quantité est obligatoire',
        success: 'Transaction modifiée avec succès',
        pin: 'Code PIN',
        km: 'Kilométrage'
      },
      loyalty: {
        solde: 'Solde cagnotte',
        amount_use: 'Montant à utiliser',
        part_pay: 'Paiement partiel',
        pay: 'Payer {amount} avec la cagnotte',
        dont_use: 'Ne pas utiliser la cagnotte',
        left_pay: 'Reste à payer',
        offers: 'Offres disponibles',
        click_offer: 'Cliquez pour utliser le bon',
        click_offer_multiple: 'Sélectionnez un ou plusieurs bons pour les utiliser',
        use_offer: 'Utiliser les bons sélectionnés',
        use_all_offers: 'Utiliser le maximum de bons',
        not_use_offer: 'Ne pas utiliser de bon',
        amount_discount: 'Montant à remiser',
        use: 'Utiliser',
        gift_solde: 'Solde carte cadeau',
        gift_reload: 'Montant à recharger',
        gift_use: 'Montant à utiliser'
      },
      cashless: {
        solde: 'Solde du compte en ligne',
        amount_use: 'Montant à utiliser',
        partial: 'Rechargement partiel',
        pay: 'Recharger de {amount}',
        cancel: 'Annuler'
      },
      voucher: {
        scan: 'confirmer',
        submit: 'consommer',
        subTitle: 'Souhaitez vous consommer ?',
      },
      prog_time: 'Heure de programmation',
      new_password: 'Nouveau mot de passe',
      password_required: 'Mot de passe requis',
      client_edit: 'Modification des informations du client',
      client_name: 'Nom du client',
      trx_in_wait: 'Vous avez {nb} transactions en attente',
      trx_bank: 'Bancaires:',
      trx_cashless: 'Cashless:',
      trx_donation: 'Don:',
      trx_tips: 'Pourboire:',
      send_trx: 'Envoyer les transactions',
      demo: 'Mode démonstration',
      user: 'Utilisateur',
      term: 'Terminal',
      search: 'Rechercher',
      replace: 'Remplacer',
      bad_rank: 'Le rang doit être compris entre 1 et 990',
      ids: 'Identifiants',
      trx_code: 'Code transaction',
      text_num_employe: 'Entrez un numéro employé :',
      client: 'Client / Demandeur',
      date_fin_validite: 'Date de fin de validité',
      type_carte: 'Type des titres cadeaux',
      amount_credited: 'Montant total crédité',
      amount_reloading: 'Montant du rechargement',
      nbr_credited: 'Nombre de titres scannés',
    },
    dialog: {
      cancellation_title: 'Annulation',
      change_statut_title: 'Changement de statut',
      cancellation_content: 'Pour annuler la dernière opération, cliquez sur OK',
      change_statut_content: 'La commande va passer dans le satut',
      tellecolection_title: 'Rapport fin de journée',
      tellecolection_content: 'Pour effectuer le rapport de fin de journée de cet équipement, cliquez sur OK',
      disconnection_title: 'Déconnexion',
      disconnection_content: 'En vous déconnectant, vous perdrez vos paramètres enregistrés sur cet appareil'
    },
    button: {
      // ***** Actions *****
      action_category: 'Mode de règlement',
      banking_title: 'Bancaire',
      vivawallet_title: 'VivaWallet',
      dpa_title: 'DPA',
      save: 'Sauvegarder',
      cancel: 'Annuler',
      open_settings: 'Ouvrir les paramètres',
      back: 'Retour',
      purchase: 'Effectuer un achat',
      print: 'Imprimer',
      send_by_mail: 'Envoyer par mail',
      pay: 'Payer',
      finish_session: 'Terminer la session',
      display_ticket: 'Afficher le ticket',
      gift: {
        title: 'Titres cadeaux',
        category: 'Cadeaux',
        card: {
          title: 'Cartes cadeaux',
          category: 'Cartes cadeaux',
          debit_title: 'Débit',
          debit_display: 'Débit carte',
          credit_title: 'Activation',
          credit_display: 'Activation carte'
        },
        cheque: {
          title: 'Chèques cadeaux',
          category: 'Chèques cadeaux',
          debit_title: 'Débit',
          debit_display: 'Débit chèque',
          credit_title: 'Activation',
          credit_display: 'Activation chèque'
        }
      },
      cashless: {
        title: 'Cashless',
        category: 'Cashless',
        reinit_title: 'Réinitialisation',
        reinit_display: 'Réinitialisation badge',
        credit_title: 'Rechargement',
        credit_choice_cat: 'Rechargement cashless',
        credit_choice_display: 'Rechargement {type}',
        debit_title: 'Paiement',
        debit_display: 'Paiement cashless'
      },
      lyfpay: {
        title: 'LyfPay',
        category: 'LyfPay',
        debit_title: 'Paiement',
        debit_display: 'Paiement LyfPay',
        credit_title: 'Déconsigne',
        credit_display: 'Rechargement LyfPay'
      },
      loyalty: {
        title: 'Fidélité',
        display: 'Calcul de fidélité'
      },
      // ***** Raccourcis / Scan *****
      shortcut_badge: 'Infos badge',
      shortcut_gift: 'Titres cadeaux',
      shortcut_gift_reset: 'Réinitialisation cartes cadeaux',
      shortcut_restoflash: 'Resto Flash',
      shortcut_reinit: 'Réinitialisation cashless',
      shortcut_invoice_payment: 'Scan de facture',
      shortcut_go_transactions: 'Recherche de transactions',
      shortcut_get_transactions_list: 'Lister les transactions',
      shortcut_get_transactions_search: 'Rechercher une transaction',
      shortcut_set_transactions: 'Saisir une reference',
      shortcut_scan_gift: 'Cliquer ici pour scanner vos titres cadeaux',
      shortcut_scan_mobil: 'Cliquer ici pour scanner une carte',
      scan_nfc: 'Sans contact',
      scan_qrcode: 'Scan QR Code',
      scan_keyboard: 'Saisie manuelle',
      scan_customer: 'Chercher un client',
      scan_lyfpay: 'Payer avec LyfPay',
      contact_scan_nfc: 'Scanner un badge sans contact',
      contact_scan_qrcode: 'Scanner un QR Code',
      contact_scan_keyboard: 'Saisir un numéro de carte',
      // ***** Badge infos view *****
      bi_client: 'Fiche client',
      bi_statut: 'Statut',
      bi_debit: 'Utilisation cagnotte',
      bi_transfert: 'Transfert',
      bi_transfert_partial: 'Transfert partiel',
      bi_transfert_total: 'Transfert total',
      bi_consultation: 'Consultation',
      bi_duplication: 'Duplicata',
      bi_cancelation: 'Annulation transaction',
      bi_voucher: 'Aucun voucher | Voucher (1) | Vouchers ({count})',
      // ***** Drawer *****
      dw_badge_info: 'Infos badge',
      dw_support: 'Support',
      dw_commande_info: 'Commandes Marketplace',
      dw_fin_session: 'Fin de session',
      dw_search: 'Carnet d\'adresses',
      dw_credit_carte: 'Crédit cartes',
      dw_duplication: 'Duplicata',
      dw_duplication_cb: 'Duplicata CB',
      dw_cancelation: 'Annulation',
      dw_consultation: 'Consultation',
      dw_reset: 'Recyclage carte',
      dw_telecolection: 'Rapport fin de journée',
      dw_setting: 'Paramètres',
      dw_change_shop: 'Changer de Point De Vente',
      dw_validation: 'Valider',
      dw_connection: 'Connexion',
      dw_disconnection: 'Déconnexion',
      dw_close_app: 'Quitter l\'application',
      dw_initialization: 'Initialisation',
      pax: {
        reprint_last_trs: 'Imprimer dernier ticket',
        reconciliation: 'Télé-collecte',
        remote_parameterization: 'Télé-paramétrage',
        //
        reconciliation_report: 'Télé-collecte',
        remote_parameterization_report: 'Télé-paramétrage',
        reference_parameter_report: 'Paramètres de référence',
        functionnal_parameter_report: 'Paramètres fonctionnels',
        summary_report: 'Résumé',
        terminal_summary_report: 'Résumé du terminal',
        session_summary_report: 'Résumé de la session',
        config_report: 'Configuration'
      },
      ticket: {
        e_ticket: 'E-Ticket',
        print: 'Imprimer',
        customer_card: 'Fiche client',
        home: 'Accueil',
        send: 'Envoyer le reçu',
        and_maj: 'et mettre à jour le contact',
        send_myself: 'Envoyer au point de vente',
        back: 'OK',
        back_from_external: 'Terminer'
      },
      settings: {
        banking: 'Bancaire',
        campaigns: 'Campagnes',
        about: 'A propos',
        pos: 'Point de vente',
        rank: 'Rang'
      },
      customer_card: 'Fiche client',
      finish: 'Terminer'
    },
    loader: {
      // ***** Initialisation *****
      connection: 'Connexion en cours',
      disconnection: 'Déconnexion en cours',
      neptingDisconnection: 'Envoi des transactions Nepting',
      initialisation: 'Initialisation en cours',
      session: 'Création de la session',
      session_reload: 'Renouvellement de la session',
      change_statut: 'Modification du statut de la commande en cours',
      telepametrage: 'Téléparamétrage en cours',
      initialisation_cashless: 'Initialisation du plugin cashless',
      download_catalogue: 'Téléchargement du catalogue',
      transaction_detail: 'Chargement de la transaction',
      // ***** Operations *****
      cancelation: 'Annulation en cours',
      duplication: 'Chargement du duplicata en cours',
      consultation: 'Chargement de la consultation en cours',
      tellecolection: 'Rapport de fin de journée en cours',
      dpa: 'Paiement DPA en cours',
      contact_search: 'Recherche de fiche client en cours',
      contact_search_cards: 'Recherche des supports du client en cours',
      contact_add_card: 'Ajout d\'un support client en cours',
      contact_creation: 'Création de fiche client en cours',
      contact_update: 'Mise à jour de fiche client en cours',
      send_ticket: 'Envoi du ticket en cours',
      send_transactions: 'Envoi des transactions en cours',
      transactions_search: 'Recherche des transactions en cours',
      // ***** Scan *****
      scan_support: 'Lecture du support',
      badge_search: '. | Recherche du badge en cours | Recherche du badge en cours : {count}ème tentative',
      badge_search_more: '. | Recherche avancée du badge en cours | Recherche avancée du badge en cours : {count}ème tentative',
      badge_number_search: 'Recherche du numéro du badge en cours',
      badge_reinit: 'Réinitialisation de la carte en cours',
      debit: '. | Débit en cours | Débit en cours : {count}ème tentative',
      credit: '. | Crédit en cours | Crédit en cours : {count}ème tentative',
      tranfert: 'Transfert de solde en cours',
      reload_search: 'Recherche de rechargement en ligne',
      reload_cancellation: 'Annulation du rechargement en cours',
      loyalty: 'Calcul de la fidélité en cours',
      loyalty_conso: 'Utilisation du cadeau en cours',
      voucher_conso: 'Débit de bons d\'achats en cours',
      mobil_scan :'Récupération des articles en cours',
      mobil_payment :'Paiement en cours',
      mobil_edition :'Modification de la transaction en cours',
      lyfpay_credit: 'Credit LyfPay en cours',
      lyfpay_cancellation: 'Annulation du paiement en cours',
      restoflash_payment: 'Paiement RestoFlash en cours',
      wait_treatment_trx: 'Traitement de la transaction bancaire',
      app_upgrade: 'Téléchargement en cours',
      opposition: 'Mise en opposition en cours',
      command: 'Création de la commande en cours',
      //
      printing: 'Impression en cours',
      encours: 'En cours'
    },
    success: {
      catalogue_updated: 'Catalogue mis à jour avec succès',
      database_exported: 'Base de données exportée avec succès',
      ticket_sent: 'Ticket envoyé',
      contact_updated: 'Fiche client modifiée avec succès',
      voucher_used: 'Voucher débité avec succès',
      offline_cancel_activation: 'Annulation de l\'activation réalisée avec succès',
      offline_credit: 'Crédit réalisé avec succès\nNouveau solde : {solde}',
      offline_cancel_credit: 'Annulation du rechargement effectué avec succès',
      payment: 'Paiement réalisé avec succès',
      disregards: 'Déconsigne réalisée avec succès',
      operation_cancelled: 'Opération annulée',
      reinit_cashless: 'Réinitialisation du support cashless effectué avec succès',
      reinit_gift: 'Réinitialisation de la carte cadeau réalisée avec succès',
      add_card: 'Support ajouté avec succès',
      operation: 'Opération réalisée avec succès',
      new_solde: 'Nouveau solde',
      cb_debit: 'Débit CB accepté',
      connection: 'Connexion réussie',
      nepting_connection: 'Application bancaire Nepting initialisée',
      disconnection: 'Déconnexion réussie',
      ask_signature: 'DEMANDER SIGNATURE CLIENT',
      offline_trx: 'Nombre de transactions offline en attente : {nb}',
      campaign_desactivation_success: 'Campagne désactivé avec succès',
      campaign_reactivation_success: 'Campagne réactivé avec succès',
      campaign_seuil_min_success: 'Changement de seuil minimum réalisé avec succès',
      campaign_plagechange_success: 'Changement de plage réalisé avec succès'
    },
    info: {
      qr_not_detected: 'Erreur pendant la détection de la caméra !\nLe scanner QR a été désactivé',
      nfc_disabled: 'Veuillez activer le sans contact.',
      not_nfc_or_disabled: 'Sans contact non présent ou désactivé.',
      nfc_problem: 'Erreur de lecture du sans contact ({problem})',
      offline_read_problem: 'Erreur pendant la lecture, merci de re-scanner la carte',
      offline_write_trx_problem: 'Erreur pendant l\'écriture de la transaction\nMerci de re-scanner immédiatement la carte',
      offline_write_trx_problem_rescan: "ATTENTION : La transaction n'a pas été finalisée ! Veuillez représenter la carte cashless et attendre le bip de validation",
      offline_no_reload_found: 'Aucun rechargement trouvé',
      offline_trx_light: 'Merci de vous reconnecter à Internet afin de vider les transactions en attente',
      offline_cancellation: 'Merci de scanner le badge avant d\'annuler la dernière opération',
      kilometers_required: 'Merci de saisir\nle kilométrage du véhicule',
      contact_no_result: 'Aucun résultat sur votre recherche',
      no_internet: 'Vous n\'êtes pas connecté à internet',
      wait_end_trx: 'Merci d\'attendre la fin de l\'envoi des transactions',
      scan_man_help: 'Vous êtes sur la vue de saisie manuelle, vous pouvez saisir le numéro de la carte, du chèque ou tout autre support. Le code de sécurité inscrit sur ce dernier peut vous être demandé',
      scan_choice: 'Vous pouvez choisir la technologie par défaut pour effectuer le scan du support cashless et fidélité',
      change_scan_choice: 'Pour modifier ou redéfinir vos préférences, vous pouvez vous rendre dans les',
      change_scan_choice_link: 'paramètres de l\'application.',
      re_print: 'Réimprimer le ticket ?',
      next_print: 'Imprimer ticket suivant ?',
      shortcut_customization: 'Vous pouvez personnaliser le comportement de cette touche de raccourci avec l\'une des fonctionnalités disponibles ci-dessous.',
      shortcut_memorization: 'Pour mémoriser ce choix, cliquez sur l\'étoile Favori',
      functionality: 'Fonctionnalité',
      favorite: 'Favori',
      change_preference: 'Pour modifier ou redéfinir vos préférences, vous pouvez revenir à cet écran en appuyant sur la touche raccourci de façon prolongée',
      no_loyalty_card: 'Aucune carte de fidélité associée',
      battery_low: 'Attention ! La batterie est faible : {percent}%',
      payment_preparation: 'Préparation du paiement',
      payment_waiting: 'Paiement en attente',
      trx_to_send: 'Transactions à transmettre',
      access_to_params: 'Accéder aux paramètres',
      change_scan_method: 'Changer de méthode de scan',
    },
    error: {
      no_action: 'Action non disponible !\nMerci d\'effectuer un nouveau téléparamétrage',
      offline_not_android: 'Le mode offline est disponible uniquement sur les appareils Android',
      only_pax_permitted: 'Opération disponible uniquement sur les terminaux PAX',
      cb_not_permitted: 'Opération indisponible sur ce terminal',
      // ***** Scan module *****
      session_unknown: 'Session inconnue',
      support_unknown: 'Support inconnu ou non autorisé',
      support_scanned: 'Support déjà scanné',
      online_solde_insufficient: 'Solde en ligne insuffisant',
      solde_insufficient: 'Solde insuffisant',
      solde_insufficient_more: 'Solde insuffisant, il reste {solde} sur ce badge',
      cashless_not_pme: 'Aucun porte monnaie compatible sur ce support',
      loyalty_not_found: 'Ce support ne correspond pas à une carte de fidélité',
      gift_not_find: 'Aucun titre cadeau correspondant',
      gift_not_card: 'Ce support ne correspond pas à une carte cadeau',
      gift_not_cheque: 'Ce support ne correspond pas à un chèque cadeau',
      gift_cheque_credit_not_permitted: 'Chèque déjà utilisé',
      gift_cheque_debit_not_permitted: 'Vous n\'avez pas la permission de débiter des chèques cadeau',
      gift_cheque_debit_not_coherent: 'Vous essayez de débiter un chèque cadeau d\'une valeur de {value} (solde: {solde}) avec un montant de {amount}',
      gift_cheque_solde_sup: 'Le solde est supérieur à la valeur du chèque',
      gift_cheque_solde_ko: 'Ce chèque a été partiellement débité',
      gift_card_credit_not_permitted: 'Carte vide',
      gift_card_debit_not_permitted: 'Vous n\'avez pas la permission de débiter des cartes cadeau',
      scan_retry: 'Le scan n\'a pas abouti, merci de ressayer',
      // ***** Views *****
      no_ticket: 'Aucun ticket',
      no_duplicate: 'Aucun duplicata disponible',
      no_cancellation: 'Aucune opération à annuler',
      pdv_unknown: 'Point de vente inconnu, merci de vous connecter manuellement',
      bad_pin: 'Code {type} incorrect\nnombre d\'essais restants : {try}',
      bad_pin_max: 'Code {type} incorrect et nombre d\'essais dépassé',
      offline_trx_max: 'Vous avez atteint le nombre maximum de transactions',
      offline_solde_insufficient: 'Le solde du badge est insuffisant pour annuler ce crédit',
      offline_write: 'Erreur pendant la lecture, merci de rescanner la carte',
      contact_not_permitted: 'Vous n\'avez pas la permission d\'accéder à ce contact',
      name_and_date_required: 'Merci de saisir un Nom et une Date de fin de validité',
      nfc_read_format: 'Erreur de formatage, merci de vérifier la configuration de votre lecteur',
      nfc_card_not_supported: 'Carte non supportée',
      nfc_not_detected: 'Aucun périphérique NFC détecté sur cet appareil.\nCelui-ci a été désactivé dans les paramètre de l\'application',
      cancellation: 'Erreur pendant l\'annulation',
      bad_passwd: 'Le mot de passe est incorrect',
      //
      file: 'Erreur de fichier',
      reference: 'Erreur de reference',
      no_reference: 'Absence de reference',
      network_change: 'Attention, vous avez changé de réseau pendant le débit',
      check_duplicata: 'Merci de vérifier que le duplicata correspond à votre dernière transaction.',
      display_duplicata: 'Afficher le duplicata',
      duplicate_transaction: 'Cette opération a déjà été effectuée. Souhaitez-vous afficher le ticket ?',
      long_trx: 'La transaction est anormalement longue...',
      retry_counter: 'Souhaitez-vous effectuer\nune {counter}ème tentative ?',
      retry: 'Recommencer',
      check_infos: 'Contrôler les informations',
      search_infos: 'Erreur pendant la recherche des informations',
      transaction: 'Erreur pendant la transaction',
      operation: 'Erreur pendant l\'opération',
      remote_auto: 'Erreur lors de la programmation du télé-paramétrage automatique ({error})',
      no_printer: 'Cet appareil ne dispose pas d\'imprimante',
      no_paper: 'L\'appareil est à court de papier',
      no_battery: 'L\'appareil est n\'a pas assez de batterie pour imprimer',
      //
      no_back_camera: 'La caméra arrière n\'est pas disponible',
      no_front_camera: 'La caméra avant n\'est pas disponible',
      no_camera_accepted: 'Vous avez refusé l\'accès à la caméra, souhaitez vous ouvrir les paramètres afin de l\'autoriser ?',
      no_camera_available: 'La caméra n\'est pas disponible',
      no_camera: 'Aucune caméra n\'est disponible',
      //
      no_certificate : 'Pas de certificat disponible sur ce support',
      support_not_permitted: 'Type de support non authorisé',
      value_not_permitted: 'Vous tentez de scanner un chèque d\'une valeur différente que le premier scanné',
      zero_not_permitted: 'Vous n\'avez pas la permission de créditer un titre cadeaux dont le solde n\'est pas à 0',
      value_zero: 'Vous n\'avez pas la permission de créditer un chèque cadeaux qui n\'a pas de valeur'
    },
    cashless_reload_modes: {
      cb: 'CB',
      amex: 'Amex',
      cetelem: 'Cetelem',
      virement: 'Virement',
      niners: 'Diners',
      franfinance: 'Franfinance',
      jcb: 'JCB',
      cheque: 'Chèque',
      accord_finance: 'AccordFinance',
      offert: 'Offert',
      cup: 'CUP',
      fintrax: 'Fintrax',
      autres: 'Autres',
      especes: 'Espèces',
      pme: 'PME',
      token: 'Token',
      gestion: 'Gestion',
      ecocup: 'Ecocup',
      catering: 'Catering',
      lyfpay: 'Lyfpay',
      payweb: 'CB PayWeb',
      transfert: 'Transfert Online Offline',
      lydia: 'Lydia'
    }
  },

  'en-EN': {
    title: {
      initialisation: 'Initialisation ' + name,
      index_pdv: 'Point of sales choice',
      info_badge: 'Carrier info',
      scan_voucher: 'Vouchers',
      settings: 'Settings',
      ticket: 'Ticket',
      gift_cheque_scan: 'Gift certificate scan',
      solde_transfer: 'Balance transfer',
      client_cards: 'Customer\'s cards',
      client_add_card: 'Customer\'s card adding',
      client_edit: 'Customer\'s profile',
      client_search: 'Customer search',
      parameters_lot_credit: 'Loading gift certificates',
      gift_credit: 'Gift card activation',
      gift_debit: 'Gift card debit',
      loyalty_jackpot: 'Loyalty jackpot',
      loyalty_offers: 'Loyalty offers',
      loyalty_questions: 'Loyalty KYC',
      vouchers: 'Vouchers',
      mobil_scan: 'Mobil card scan',
      mobil_products: 'Product selection',
      mobil_payment: 'Mobil debit',
      cashless_reload: 'Cashless refill',
      cashless_reload_cb: 'Refill with credit card ',
      cashless_cancel: 'Cancellation {type}',
      scan_choice: 'Scan choice',
      amount_capture: 'Amount capture',
      amount_purchase: 'Purchase amount',
      amount_tips: 'Tips amount',
      amount_transfer: 'Amount to transfer',
      validity_date: 'Expiration date',
      validity_date_selection: 'Select an expiration date',
      birth_date: 'Birthdate',
      birth_date_selection: 'Select an birthdate',
      offline_trx_nb: '{nb} offline transactions stored',
      ticket_manage: 'Bank receipt management',
      connection: 'Connection',
      requests: 'Queries',
      reports: 'Reports',
      article_details: 'Item detail',
      customer_loyalty_cards: 'Loyalty cards',
      article_price: 'Article price',
      settings_actions: 'Quick actions',
      settings_printer: 'Printer',
      settings_no_printer: 'No bluetooth printer found',
      settings_select_printer: 'Select one printer',
      settings_scan_choice: 'Choice of scan',
      settings_scan_choice_desc: 'Depending on the characteristics of your device, you can enable or disable scanning methods, as well as prioritize one',
      settings_lang: 'Languages',
      settings_lock: 'Locking',
      settings_lock_desc: 'You can set a password to limit access to certain features of the main menu, such as settings or logging out',
      settings_others: 'Other parameters',
      give_tips: 'Would you like to tip?',
      give_tips_amount: 'How much do you want to donate?',
      give_donation: 'Would you like to donate ',
      donations: 'Donation',
      tips: 'Tips',
      cashlessRefill: 'Cashless refill'
    },
    enums: {
      type_scan: {
        nfc: 'Contactless',
        qr: 'QR Code',
        swipe: 'Swipe',
        manual: 'Manual entry',
        qr_usb: 'QR Code USB'
      },
      orientation: {
        portrait: 'Portrait',
        landscape: 'Landscape',
        invert_portrait: 'Inverted portrait',
        invert_landscape: 'Inverted landscape'
      },
      env: {
        choice: 'Choice of environment',
        settings: 'Settings access',
        bdd: 'Export the local database',
        pax_bdd: 'Export the PAX database',
        prod: 'Production',
        int: 'Integration',
        dev: 'Development'
      }
    },
    words: {
      payment: 'Payment',
      valid: 'To validate',
      disable: 'disable',
      disabled: 'disabled',
      deactivationRange: 'deactivation range',
      reactivation: 'Reactivation',
      cancel: 'Cancel',
      cancelled: 'cancelled',
      refused: 'refused',
      ripped_card: 'Ripped card',
      trx: {
        refused: 'Refused transaction',
        cancelled: 'Cancelled transaction',
        error: 'Transaction in error'
      },
      left_to_pay: 'Left to pay',
      solde: 'Balance',
      amount: 'Amount',
      beneficiary: 'Beneficiary',
      gateway: 'Gateway',
      instance: 'Contrat'
    },
    tickets: {
      old_solde: 'OLD BALANCE',
      activation_fees: 'ACTIVATION FEES',
      new_solde: 'NEW BALANCE',
      follow_us: 'Follow your cashless account by registering on',
      add_code: 'Add your badge with the code',
      thx: 'THANK YOU, SEE YOU SOON',
      reload: 'RELOAD',
      payment: 'PAYMENT',
      cancel_reload: 'RELOAD CANCELLATION',
      cancel_payment: 'PAYMENT CANCELLATION',
      offline_site: 'Follow your cashless account by registering on',
      offline_code: 'Add your badge with the code'
    },
    field: {
      index: {
        user: 'e-mail',
        password: 'Password',
        pdv: 'Point of sale',
        licence: 'Licence',
        rank: 'Rank',
        version: 'Version #'
      },
      pax: {
        web_service_url: 'Nepting web service URL',
        merchant_code: 'Nepting merchant ID',
        server: 'Production server',
        pos_number: 'Terminal number'
      },
      settings: {
        print_merchant_ticket: 'Print merchant ticket',
        print_client_ticket: 'Print customer ticket',
        manage_tickets: 'Manage Nepting tickets',
        do_remote_settings: 'Download settings',
        update_catalog: 'Update product catalog',
        update_app: 'Update myTerminal',
        language: 'Language',
        orientation: 'Screen orientation',
        scan_tech: 'Default scan technology',
        passwd: 'Password',
        contactless: 'Contactless',
        qr_code: 'QrCode',
        man_scan: 'Manual entry',
        swipe: 'Swipe reading',
        vibration: 'Vibration keys',
        startWithAndroid: 'Start with Android',
        lock_standby: 'Standby lock',
        darkening: 'Darkening',
        darkening_delay: 'Darkening delay',
        remote_auto: 'Auto download settings',
        printer_connected: 'Connected:',
        printer_forgot: 'Forgot printer',
        printer_test: 'Print test',
        printer_connect_new: 'Connect bluetooth printer',
        seuil_min: 'Minimal treshold',
        any_minimal_threshold: 'Any minimal threshold'
      },
      scan: {
        pin_code_capture: '{type} code capture',
        pin_code: '{type} code',
        thx_presenting: 'please approach',
        thx_again: 'again',
        ur_badge: 'your badge for informations',
        ur_support: 'your support',
        ur_payment: 'your means of payment',
        recharge: 'Credit of',
        dispo: 'available',
        cancel_recharge: 'Cancel credit',
        support_number: 'Support number',
        transaction_number: 'Transaction number',
        group_op: 'Group operations',
        program_selection: 'Program selection',
        program_bail: 'Deposit',
        program_date_start: 'Start date',
        program_hour_start: 'beginning hour',
        program_date_end: 'End date',
        program_hour_end: 'End time',
        reload_code: 'Reload code',
        ticket_number: 'Ticket number',
        reload: 'Refill',
        reload_online: 'Online refill',
        prepayment: 'Online pre-payment required',
        no_trx_card: 'No transaction is present on this card',
        cancel_op: 'Cancel this operation',
        debit: 'Debit',
        credit: 'Credit',
        credit_online: 'Online credit',
        cancel_credit: 'Credit cancel',
        cancel_debit: 'Debit cancel',
        activation_fee: 'Activation fees'
      },
      customer: {
        name: 'Name',
        firstname: 'Firstname',
        mail: 'e-mail',
        country_code: 'Country code',
        country: 'Choose a country',
        phone: 'Phone',
        phone_number: 'Phone number',
        example: 'Example: ',
        address_search: 'Address search',
        address_capture: 'Enter an address',
        address: 'Address',
        address_comp: 'Additional address',
        cp: 'Postal code',
        city: 'City',
        status_registered: 'Registered',
        status_to_complet: 'To be completed',
        status_disabled: 'Unactivated',
        purchase: 'Register a purchase',
        mail_name_phone: 'Enter mail / name / phone',
        new_customer: 'New customer',
        create_new_customer: 'Create new customer'
      },
      mobil: {
        no_product: 'No product available',
        quantity: 'Quantity',
        total: 'Total amount',
        add: 'add',
        edit: 'Edit',
        total_and: ' A total amount AND a quantity are required',
        total_or: 'A total amount OR a quantity is required',
        success: 'Transaction successfully edited',
        pin: 'Pin code',
        km: 'Mileage'
      },
      loyalty: {
        solde: 'Money pot balance',
        amount_use: 'Amount to use',
        part_pay: 'Partial payment',
        pay: 'Pay {amount} with the pot',
        dont_use: 'Do not use the pot',
        left_pay: 'Left to pay',
        offers: 'Available offers',
        click_offer: 'Click to use the offer',
        click_offer_multiple: 'Select one or more offers to use them',
        use_offer: 'Use offer(s)',
        use_all_offers: 'Use all offers',
        not_use_offer: 'Do not use any offer',
        amount_discount: 'Amount discounted',
        use: 'Use',
        gift_solde: 'Gift card balance',
        gift_reload: 'Amount to top up',
        gift_use: 'Available amount'
      },
      cashless: {
        solde: 'Solde online',
        amount_use: 'Amount to use',
        partial: 'Partial refill',
        pay: 'Refill {amount}',
        cancel: 'Cancel'
      },
      voucher: {
        scan: 'confirm',
        submit: 'consume',
        subTitle: 'Would you like to consume?',
      },
      prog_time: 'Scheduled time',
      new_password: 'New password',
      password_required: 'Password is required',
      client_edit: 'Edit customer information',
      client_name: 'Customer name',
      trx_in_wait: 'You have {nb} pending transactions',
      trx_bank: 'Banking:',
      trx_cashless: 'Cashless:',
      trx_donation: 'Donation:',
      trx_tips: 'Tips:',
      send_trx: 'Upload transactions',
      demo: 'Demonstration mode',
      user: 'User',
      term: 'Terminal',
      search: 'Search',
      replace: 'Replace',
      bad_rank: 'Rank must be between 1 and 990',
      ids: 'Identifiers',
      trx_code: 'Transaction code',
      infos: 'Information',
      supports: 'Medium',
      client: 'Client / Requester',
      date_fin_validite: 'End of validity date',
      type_carte: 'Type of gift certificate',
      amount_credited: 'Total amount credited',
      amount_reloading: 'Top-up amount',
      nbr_credited: 'Number of titles scanned',
      reload_amount: 'Montant du rechargement',
    },
    dialog: {
      cancellation_title: 'Cancellation',
      cancellation_content: 'To cancel the last operation, clic OK',
      tellecolection_title: 'End of day report',
      tellecolection_content: 'Do you want to initiate device\'s end of day report ?',
      disconnection_title: 'Logout',
      disconnection_content: 'By logging out, you will loose your saved settings on this device'
    },
    button: {
      // ***** Actions *****
      action_category: 'Payment modes',
      banking_title: 'Bank',
      vivawallet_title: 'VivaWallet',
      dpa_title: 'DPA',
      save: 'Save',
      open_settings: 'Open settings',
      back: 'Back',
      cancel: 'Cancel',
      purchase: 'Make a purchase',
      print: 'To print',
      send_by_mail: 'Send by mail',
      pay: 'To pay',
      finish_session: 'End session',
      display_ticket: 'Show ticket',
      gift: {
        title: 'Gift titles',
        category: 'Gifts',
        card: {
          title: 'Gift cards',
          category: 'Gift cards',
          debit_title: 'Debit',
          debit_display: 'Card debit',
          credit_title: 'Activation',
          credit_display: 'Card activation'
        },
        cheque: {
          title: 'Gift certificates',
          category: 'Gift certificates',
          debit_title: 'Debit',
          debit_display: 'Gift cert. debit',
          credit_title: 'Enabling',
          credit_display: 'Enabling gift cert.'
        },
      },
      cashless: {
        title: 'Cashless',
        category: 'Cashless',
        reinit_title: 'Reset',
        reinit_display: 'Carrier reset',
        credit_title: 'Refill',
        credit_choice_cat: 'Cashless refill',
        credit_choice_display: 'Refill {type}',
        debit_title: 'Payment',
        debit_display: 'Cashless payment'
      },
      lyfpay: {
        title: 'LyfPay',
        category: 'LyfPay',
        debit_title: 'Payment',
        debit_display: 'LyfPay payment',
        credit_title: 'Deposit',
        credit_display: 'LyfPay refill'
      },
      loyalty: {
        title: 'Loyalty',
        display: 'Loyalty calculation'
      },
      // ***** Raccourcis / Scan *****
      shortcut_badge: 'Carrier info',
      shortcut_gift: 'Gift titles',
      shortcut_gift_reset: 'Gift cards reset',
      shortcut_restoflash: 'Resto Flash',
      shortcut_reinit: 'Cashless reset',
      shortcut_invoice_payment: 'Invoice scan',
      shortcut_get_transactions_list: 'Get transactions',
      shortcut_get_transactions_search: 'search transaction',
      shortcut_set_transactions: 'Register reference',
      shortcut_scan_gift: 'Press here to scan your gift cert.',
      shortcut_scan_mobil: 'Press here to scan your card',
      scan_nfc: 'Contactless scan',
      scan_qrcode: 'QR Code scan',
      scan_keyboard: 'Manual keyboard',
      scan_customer: 'Find customer',
      scan_lyfpay: 'Pay with LyfPay',
      contact_scan_nfc: 'Contactless scan',
      contact_scan_qrcode: 'QR Code scan',
      contact_scan_keyboard: 'Enter a card number',
      // ***** Badge infos view *****
      bi_client: 'Customer info',
      bi_debit: 'Use jackpot',
      bi_transfert: 'Transfer',
      bi_transfert_partial: 'Partial transfer',
      bi_transfert_total: 'Full transfer',
      bi_consultation: 'View details',
      bi_duplication: 'Duplicata',
      bi_cancelation: 'Cancellation transaction',
      bi_voucher: 'No voucher | Vouchers ({count})',
      // ***** Drawer *****
      dw_badge_info: 'Carrier info',
      dw_search: 'Search',
      dw_duplication: 'Duplicata',
      dw_duplication_cb: 'Duplicata CB',
      dw_cancelation: 'Cancellation',
      dw_consultation: 'Display',
      dw_telecolection: 'Datacollection',
      dw_reset: 'Recycling card',
      dw_setting: 'Settings',
      dw_change_shop: 'Point of sales switch',
      dw_validation: 'Validate',
      dw_connection: 'Login',
      dw_disconnection: 'Logout',
      dw_close_app: 'Close application',
      dw_initialization: 'Initialization',
      pax: {
        reprint_last_trs: 'Reprint last trans.',
        reconciliation: 'Reconciliation',
        remote_parameterization: 'Donwload settings',
        //
        reconciliation_report: 'Reconciliation',
        remote_parameterization_report: 'Remote settings',
        reference_parameter_report: 'Reference settings',
        functionnal_parameter_report: 'Functional settings',
        summary_report: 'Summary',
        terminal_summary_report: 'Terminal Summary',
        session_summary_report: 'Session Summary',
        config_report: 'Config'
      },
      ticket: {
        e_ticket: 'E-Ticket',
        print: 'Print',
        customer_card: 'Customer card',
        home: 'Home',
        send: 'Send',
        and_maj: 'and update contact',
        send_myself: 'Send to me',
        back: 'OK',
        back_from_external: 'Finish'
      },
      settings: {
        banking: 'Banking',
        campaigns: 'Campaigns',
        about: 'About',
        pos: 'Point Of Sale',
        rank: 'Rank'
      },
      customer_card: 'Customer card',
      finish: 'Finish'
    },
    loader: {
      // ***** Initialisation *****
      connection: 'Establishing connection',
      disconnection: 'Logout in process',
      neptingDisconnection: 'Sending Nepting transactions',
      initialisation: 'Initializing',
      session: 'Session creation',
      session_reload: 'Session renewal',
      telepametrage: 'Updating remote settings',
      initialisation_cashless: 'Cashless plugin initializing',
      download_catalogue: 'Catalog download',
      transaction_detail: 'Transaction loading',
      // ***** Operations *****
      cancelation: 'Processing cancellation',
      duplication: 'Processing duplicata',
      consultation: 'Loading info',
      tellecolection: 'Ongoing datacollection',
      dpa: 'Processing DPA payment',
      contact_search: 'Searching for customer details',
      contact_search_cards: 'Searching for customer cards',
      contact_add_card: 'Adding customer card',
      contact_creation: 'Storing first-time customer information',
      contact_update: 'Updating customer information',
      send_ticket: 'Sending ticket',
      send_transactions: 'Uploading transactions',
      transactions_search: 'Processing transactions search',
      // ***** Scan *****
      scan_support: 'Reading carrier',
      badge_search: '. | Carrier search | Carrier search : #{count} try',
      badge_search_more: '. | Processing advanced carrier search | Processing advanced carrier search : #{count} try',
      badge_number_search: 'Processing carrier number search ',
      badge_reinit: 'Processing reset of current carrier ',
      debit: '. | Processing debit | Processing debit : #{count} try',
      credit: '. | Processing credit | Processing credit : #{count} try',
      tranfert: 'Processing balance transfer',
      reload_search: 'Searching for online credit',
      reload_cancellation: 'Cancelling current refill',
      loyalty: 'Processing loyalty',
      loyalty_conso: 'Using loyalty gift',
      voucher_conso: 'Using voucher(s)',
      mobil_scan :'Selecting applicable items from catalog',
      mobil_payment :'Processing payment',
      mobil_edition :'Processing transaction edition',
      lyfpay_credit: 'Processing LyfPay credit',
      lyfpay_cancellation: 'Processing payment cancellation ',
      restoflash_payment: 'Processing Restoflash payment',
      wait_treatment_trx: 'Processing banking transaction',
      app_upgrade: 'Download in progress',
      opposition: 'Opposition in progress',
      command: 'Command creation in progress',
      //
      printing: 'Printing in progress',
      encours: 'In progress'
    },
    success: {
      catalogue_updated: 'Catalog successfully updated',
      database_exported: 'Database successfully updated',
      ticket_sent: 'Ticket sent',
      contact_updated: 'Contact successfully updated',
      voucher_used: 'Voucher successfully used',
      offline_cancel_activation: 'Cancellation of carrier activation successfully ended',
      offline_credit: 'Credit completed \nNew balance : {solde}',
      offline_cancel_credit: 'Cancellation of credit successfully processed',
      payment: 'Payment completed',
      disregards: 'Deposit refunded successfully',
      operation_cancelled: 'Operation cancelled',
      reinit_cashless: 'Cashless support reinitialization successfully',
      reinit_gift: 'Gift card reinitialization successfully',
      add_card: 'Adding support successfully',
      operation: 'Operation successfully completed',
      new_solde: 'New Balance',
      cb_debit: 'CB debit accepted',
      connection: 'Successful connection',
      nepting_connection: 'Successful Nepting banking connection',
      disconnection: 'Successful logout',
      ask_signature: 'ASK CUSTOMER SIGNATURE',
      offline_trx: 'Number of pending offline/(not uploaded) transactions',
      campaign_desactivation_success: 'Campaign deactivated successfully',
      campaign_reactivation_success: 'Campaign reactivated successfully',
      campaign_seuil_min_success: 'Minimum threshold change successfully',
      campaign_plagechange_success: 'Range change completed successfully'
    },
    info: {
      qr_not_detected: 'Hardware camera not detected !\nQR scanner has been deactivated',
      nfc_disabled: 'Please allow contacless sensor.',
      not_nfc_or_disabled: 'Missing contactless device or currently deactivated.',
      nfc_problem: 'Contactless error: ({problem})',
      offline_read_problem: 'Carrier read error, please rescan',
      offline_write_trx_problem: 'Transaction write error\nPlease scan carrier again immediately',
      offline_no_reload_found: 'No refill cash found',
      offline_trx_light: 'Please enable communications on this device to send transactions',
      offline_cancellation: 'Please scan carrier first, before cancellation',
      kilometers_required: 'Please enter mileage',
      contact_no_result: 'No result found',
      no_internet: 'The device has no useful acces to mobile data ',
      wait_end_trx: 'Please wait until all transactions are uploaded',
      scan_man_help: 'You are on the manual scan view, you can enter the number of the card or the check. You may be asked for the security code written on it.',
      scan_choice: 'You can choose the default mean to scan cashless and loyalty support',
      change_scan_choice: 'To modify or redefine your preferences, you can go to the',
      change_scan_choice_link: 'application settings',
      re_print: 'Print again the ticket?',
      next_print: 'Print the next ticket?',
      shortcut_customization: 'You can customize the behavior of this hotkey with any of the features available below',
      shortcut_memorization: 'To store this choice, click on the Favorite star',
      functionality: 'Functionality',
      favorite: 'Favorite',
      change_preference: 'To modify or redefine your preferences, you can come back to this screen by pressing and holding the shortcut key.',
      no_loyalty_card: 'No linked loyalty card',
      battery_low: 'Warning ! The battery is low : {percent}%',
      payment_preparation: 'Preparing payment',
      payment_waiting: 'Waiting for payment',
      trx_to_send: 'Transactions to be transmitted',
      access_to_params: 'Access settings',
      change_scan_method: 'Change scan method'
    },
    error: {
      no_action: 'Unable to process !\nPlease restart remote settings',
      offline_not_android: 'Offline mode is only available on Android devices',
      only_pax_permitted: 'Only PAX available',
      cb_not_permitted: 'Operation not available on this terminal',
      // ***** Scan module *****
      session_unknown: 'Unknown session',
      support_unknown: 'Unknown or unauthorized carrier',
      support_scanned: 'Carrier already scanned',
      online_solde_insufficient: 'Online balance is too low',
      solde_insufficient: 'Balance is too low',
      solde_insufficient_more: 'Balance is too low, {solde} on the carrier',
      cashless_not_pme: 'No compatible wallet found on the carrier',
      loyalty_not_found: 'No loyalty system found on this carrier',
      gift_not_find: 'No matching gift certificate found',
      gift_not_card: 'No matching gift card found',
      gift_not_cheque: 'No matching gift certificate found',
      gift_cheque_credit_not_permitted: 'Gift certificate used',
      gift_cheque_debit_not_permitted: 'You don\'t have the permission to use gift certificates',
      gift_cheque_debit_not_coherent: 'You are trying to use a {value} gift certificate (balance: {solde}), amount {amount}',
      gift_cheque_solde_sup: 'Balance is greater than gift certificate value',
      gift_cheque_solde_ko: 'This gift certificate has already been partially used',
      gift_card_credit_not_permitted: 'Empty card',
      gift_card_debit_not_permitted: 'You don\'t have the permission to use gift cards',
      // ***** Views *****
      no_ticket: 'No ticket',
      no_duplicate: 'No duplicata available',
      no_cancellation: 'Nothing to cancel',
      pdv_unknown: 'Unkown point of sales, please connect manually',
      bad_pin: 'Wrong {type} code\n{try} attempt(s) left',
      bad_pin_max: 'Wrong {type} code and maxium attempts reached',
      offline_trx_max: 'Maximum transaction count reached. Please connect to mobile data to continue',
      offline_solde_insufficient: 'Carrier balance is too low to cancel credit',
      offline_write: 'Carrier read error, please rescan carrier',
      contact_not_permitted: 'You don\'t have permission to read contact details (GDPR)',
      name_and_date_required: 'Thanks to fill in name and expiration date',
      nfc_read_format: 'Format error, check your hardware',
      nfc_card_not_supported: 'Non-supported carrier',
      nfc_not_detected: 'No NFC reader found, could be disabled at the application or device level',
      cancellation: 'Problem happened during cancellation',
      bad_passwd: 'Bad password',
      //
      file: 'File error',
      reference: 'Reference error',
      no_reference: 'Missing reference',
      network_change: 'Be careful, you have changed network',
      check_duplicata: 'Please check that the duplicate corresponds to your last transaction.',
      display_duplicata: 'Show duplicate',
      duplicate_transaction: 'This operation has already been performed. Would you like to show the ticket?',
      long_trx: 'The transaction is unusually long...',
      retry_counter: 'Would you like to make another attempt ({counter}) ?',
      retry: 'Restart',
      check_infos: 'Control information',
      search_infos: 'Error while searching for information',
      transaction: 'Error during transaction',
      operation: 'Error during operation',
      remote_auto: 'Error when applying the automatic remote settings ({error})',
      no_printer: 'This device does not seem to have a printer',
      no_paper: 'This device is short on print paper',
      no_battery: 'This device does not have enough battery power to print, printing is disabled',
      //
      no_back_camera: 'Rear camera is not available',
      no_front_camera: 'Front camera is not available',
      no_camera_accepted: 'You have refused access to the camera, do you want to open the settings to authorize it ?',
      no_camera_available: 'Camera is not available',
      no_camera: 'No camera is available',
      support_not_permitted: 'Unauthorized media type',
      value_not_permitted: 'You are trying to scan a check with a different value than the first one scanned',
      zero_not_permitted: 'You do not have permission to credit a gift voucher whose balance is not at 0',
      value_zero: 'You do not have permission to credit a gift card that has no value'
    },
    cashless_reload_modes: {
      cb: 'CB',
      amex: 'Amex',
      cetelem: 'Cetelem',
      virement: 'Transfer',
      niners: 'Diners',
      franfinance: 'Franfinance',
      jcb: 'JCB',
      cheque: 'Bank check',
      accord_finance: 'AccordFinance',
      offert: 'Free',
      cup: 'CUP',
      fintrax: 'Fintrax',
      autres: 'Other',
      especes: 'Cash',
      pme: 'ECH',
      token: 'Token',
      gestion: 'Management',
      ecocup: 'Ecocup',
      catering: 'Catering',
      lyfpay: 'Lyfpay',
      payweb: 'CB PayWeb',
      transfert: 'Transfer Online Offline',
      lydia: 'Lydia'
    }
  }

  // 'Besse': {
  //   title: {
  //     initialisation: 'Initialisation BESSE'
  //   }
  // }
}
